var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authenticated)?_c('v-app',[_c('LeftMenu'),_c('TopMenu'),_c('v-main',[_c('div',{staticClass:"app-content-container pa-6"},[_vm._t("default")],2)]),_c('Footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }